import { makeStyles } from '@material-ui/core/styles';
import { LogoMark } from './LogoMark';

const CYAN = '#38D7FF';
const LIME = '#DDFF6B';

const useStyles = makeStyles({
  '@keyframes rise': {
    from: { opacity: 0, transform: 'translateY(3px)' },
    to: { opacity: 1, transform: 'none' },
  },
  '@keyframes pulse': {
    '0%': { opacity: 0.55, transform: 'scale(1)' },
    '70%, 100%': { opacity: 0, transform: 'scale(2.6)' },
  },
  svg: {
    width: 'auto',
    height: 38,
    overflow: 'visible',
    '&:hover $title': { letterSpacing: '0.2px' },
  },
  title: {
    fill: '#FFFFFF',
    fontFamily: '"Space Grotesk", Inter, system-ui, sans-serif',
    fontSize: 19,
    fontWeight: 700,
    letterSpacing: '-0.3px',
    transition: 'letter-spacing 300ms ease',
    animation: '$rise 500ms ease-out both',
  },
  domain: {
    fill: CYAN,
    fillOpacity: 0.8,
    fontFamily: '"JetBrains Mono", ui-monospace, monospace',
    fontSize: 8.5,
    fontWeight: 500,
    letterSpacing: '0.6px',
    animation: '$rise 500ms ease-out 120ms both',
  },
  dot: { fill: LIME },
  ring: {
    fill: LIME,
    transformBox: 'fill-box',
    transformOrigin: 'center',
    animation: '$pulse 2.8s ease-out 1s infinite',
  },
  '@media (prefers-reduced-motion: reduce)': {
    title: { animation: 'none' },
    domain: { animation: 'none' },
    ring: { animation: 'none', opacity: 0 },
  },
});

/**
 * Sidebar logo, open state: the orange Digistore24 mark, "backstage" in the
 * display face and the domain as a small mono label with a live dot, as in
 * the launch video's title cards.
 */
const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -1 140 30"
      role="img"
      aria-label="backstage.ds25.io"
    >
      <LogoMark />
      <text x="33" y="16" className={classes.title}>
        backstage
      </text>
      <circle cx="35.5" cy="24.6" r="1.8" className={classes.ring} />
      <circle cx="35.5" cy="24.6" r="1.8" className={classes.dot} />
      <text x="40.5" y="27.5" className={classes.domain}>
        ds25.io
      </text>
    </svg>
  );
};

export default LogoFull;
